/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import ScrollView from "devextreme-react/scroll-view";
import appInfo from "../../app-info";
import "./style.scss";
import useTheme from "../../services/theme";
import { useScreenSize } from "../../utils/media-query";

export default function SingleCard({ className, children }) {
  const { themeColor } = useTheme();
  const { isXSmall } = useScreenSize();
  return (
    <ScrollView
      height={"100%"}
      width={"100%"}
      className={`single-card ${className}`}
    >
      <div className={"content"}>
        <div className={"dx-card"}>
          <div className={"header"}>
            <div className={"logo"}>
              <img
                src={themeColor === "light" ? appInfo.logo : appInfo.logoDark}
                height={isXSmall ? "40" : "40"}
                width={isXSmall ? "230" : "auto"}
              />
            </div>
          </div>
          {children}
        </div>
        <img src="/assets/images/bg-login.png" alt="" className="bg-login" />
      </div>
    </ScrollView>
  );
}
